const {
  CHILD_AGE_MINIMUM_DAYS,
  CHILD_AGE_MAXIMUM_DAYS,
  FEVER_THRESHOLD_CHILD_INCLUSIVE,
  FEVER_THRESHOLD_NON_CHILD_INCLUSIVE,
  HYPOTHERMIA_THRESHOLD_EXCLUSIVE,
} = require('../utilities/convertConstants');

// calculates whether a given temperature corresponds to fever for given age
const tempHigh = (age, temp) => {
  const tempNum = parseFloat(temp);

  if (age < CHILD_AGE_MINIMUM_DAYS || age > CHILD_AGE_MAXIMUM_DAYS) {
    return tempNum >= FEVER_THRESHOLD_NON_CHILD_INCLUSIVE;
  }

  return tempNum >= FEVER_THRESHOLD_CHILD_INCLUSIVE;
};

// calculates whether given temperature is hypothermia
const tempLow = (temp) => {
  const tempNum = parseFloat(temp);

  return tempNum < HYPOTHERMIA_THRESHOLD_EXCLUSIVE;
};

module.exports = {
  tempHigh,
  tempLow,
};
